import { forwardRef, type SVGProps } from 'react';

export const Plus = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path
        d="M0 12a1.5 1.5 0 0 0 1.5 1.5h8.75a.25.25 0 0 1 .25.25v8.75a1.5 1.5 0 0 0 3 0v-8.75a.25.25 0 0 1 .25-.25h8.75a1.5 1.5 0 0 0 0-3h-8.75a.25.25 0 0 1-.25-.25V1.5a1.5 1.5 0 0 0-3 0v8.75a.25.25 0 0 1-.25.25H1.5A1.5 1.5 0 0 0 0 12z"
        fill="currentColor"
      />
    </g>
  </svg>
));

export const PlusCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path d="M12 23.75A11.75 11.75 0 1 0 .25 12 11.764 11.764 0 0 0 12 23.75zm0-21A9.25 9.25 0 1 1 2.75 12 9.26 9.26 0 0 1 12 2.75z" />
      <path d="M6.273 13.25H10.5a.25.25 0 0 1 .25.25v4.227a1.25 1.25 0 0 0 2.5 0V13.5a.25.25 0 0 1 .25-.25h4.227a1.25 1.25 0 0 0 0-2.5H13.5a.25.25 0 0 1-.25-.25V6.272a1.25 1.25 0 1 0-2.5 0V10.5a.25.25 0 0 1-.25.25H6.273a1.25 1.25 0 0 0 0 2.5z" />
    </g>
  </svg>
));

export const PlusSquare = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path
        d="M23.5 2A1.5 1.5 0 0 0 22 .5H2A1.5 1.5 0 0 0 .5 2v20A1.5 1.5 0 0 0 2 23.5h20a1.5 1.5 0 0 0 1.5-1.5zM6 13a1 1 0 0 1 0-2h4.75a.25.25 0 0 0 .25-.25V6a1 1 0 0 1 2 0v4.75a.25.25 0 0 0 .25.25H18a1 1 0 0 1 0 2h-4.75a.25.25 0 0 0-.25.25V18a1 1 0 0 1-2 0v-4.75a.25.25 0 0 0-.25-.25z"
        fill="currentColor"
      />
    </g>
  </svg>
));

export const PlusSquareOutline = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path d="M5.33334 8H10.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 10.6667V5.33337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.00001 14.6667H10C13.3333 14.6667 14.6667 13.3334 14.6667 10V6.00004C14.6667 2.66671 13.3333 1.33337 10 1.33337H6.00001C2.66668 1.33337 1.33334 2.66671 1.33334 6.00004V10C1.33334 13.3334 2.66668 14.6667 6.00001 14.6667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export const PlusBlob = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props} ref={ref}>
    <path
      fill="#2883FF"
      d="M20.29 5.09c1.72 2.105 2.084 5.388 1.354 8.327-.742 2.939-2.579 5.52-5.223 7.07-2.645 1.548-6.083 2.065-8.78.807-2.683-1.245-4.611-4.276-5.328-7.546-.716-3.283-.221-6.804 1.668-8.949 1.875-2.131 5.158-2.873 8.337-2.793 3.178.092 6.252.993 7.972 3.084z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7.254 12a.9.9 0 01.9-.9h7.69a.9.9 0 010 1.8h-7.69a.9.9 0 01-.9-.9z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12 7.242a.9.9 0 01.9.9v7.69a.9.9 0 01-1.8 0v-7.69a.9.9 0 01.9-.9z"
      clipRule="evenodd"
    />
  </svg>
));
